var map = {
	"./4.png": 54717,
	"./cVOL.png": 71235,
	"./ciAAPL.png": 3268,
	"./ciAMZN.png": 75564,
	"./ciBOLD.png": 77603,
	"./ciBRL.png": 86243,
	"./ciDASH.png": 86020,
	"./ciDEFI12.png": 29347,
	"./ciDPI.png": 24772,
	"./ciFB.png": 17867,
	"./ciGBP.png": 82720,
	"./ciGOOGL.png": 11407,
	"./ciLTC.png": 91970,
	"./ciMSFT.png": 69938,
	"./ciMUSK.png": 33801,
	"./ciPRIV.png": 52109,
	"./ciSDR.png": 44102,
	"./ciSPY.png": 55563,
	"./ciTSLA.png": 7792,
	"./ciUSD.png": 29818,
	"./ciXAG.png": 32078,
	"./ciXAU.png": 64543,
	"./ciXMR.png": 69056,
	"./ciXPT.png": 42949,
	"./ciYEN.png": 47558,
	"./ciZCASH.png": 16411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66653;